import { Modal } from "react-bootstrap";
import AddressList from "containers/property/AddressList";

function AddressModal({
    isAuthenticated,
    user,
    show,
    onClose,
    filter,
    saveForm,
    data,
    updateTableState,
    saveRecord,
    deleteRecord,
    validateRelatedRecord,
    streetOptions,
}) {

    return (
        <Modal id="property-address-modal" show={show} onHide={onClose} dialogClassName="property-table-modal-wide">
            <Modal.Header closeButton>
                <Modal.Title>Addresses</Modal.Title>
            </Modal.Header>
            <Modal.Body id="property-address-modal-body">
                <AddressList
                    filter={filter}
                    isAuthenticated={isAuthenticated}
                    isLoading={false}
                    controlType="table"
                    saveForm={saveForm}
                    user={user}
                    data={data}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    deleteRecord={deleteRecord}
                    validateRelatedRecord={validateRelatedRecord}
                    streetOptions={streetOptions}
                />
            </Modal.Body>
        </Modal>
    );
}
export default AddressModal;